import { Routes } from '@angular/router';

import { hisChildRoutes } from 'hisng';

import { PersonSearchFormComponent } from './component/person/person-search-form.component';
import { PersonSearchResultComponent } from './component/person/person-search-result.component';
import { PersonDetailViewComponent } from './component/person/person-detail-view.component';
import { UnitSearchResultComponent } from './component/person/unit-search-result.component';
import { UnitSearchFormComponent } from './component/person/unit-search-form.component';
import { PersonIdAssignmentFormComponent } from './component/idAssignment/person-id-assignment-form.component';
import { PersonProfileEditFormComponent } from './component/profile/personprofile-edit-form.component';

const ROUTES: Routes = [
    {
        path: 'search',
        component: PersonSearchFormComponent,
        data: {
            hasAny: [
                'RIGHT_CS_PSV_ORGTREE_VIEW_AFFILIATION',
                'RIGHT_CS_PSV_ORGTREE_VIEW_ORGUNIT_TREE',
                'RIGHT_CS_PSV_ORGTREE_SEARCH_AFFILIATION',
                'RIGHT_CS_PSV_ORGTREE_SEARCH_ORGUNIT'
            ]
        }
    },
    {
        path: 'searchresult',
        component: PersonSearchResultComponent,
        data: {
            hasAny: [
                'RIGHT_CS_PSV_ORGTREE_VIEW_AFFILIATION',
                'RIGHT_CS_PSV_ORGTREE_VIEW_ORGUNIT_TREE',
                'RIGHT_CS_PSV_ORGTREE_SEARCH_AFFILIATION',
                'RIGHT_CS_PSV_ORGTREE_SEARCH_ORGUNIT'
            ]
        }
    },
    {
        path: 'view/:personId',
        component: PersonDetailViewComponent,
        data: {
            hasAny: [
                'RIGHT_CS_PSV_ORGTREE_VIEW_AFFILIATION',
                'RIGHT_CS_PSV_ORGTREE_VIEW_ORGUNIT_TREE',
                'RIGHT_CS_PSV_ORGTREE_SEARCH_AFFILIATION',
                'RIGHT_CS_PSV_ORGTREE_SEARCH_ORGUNIT'
            ]
        }
    },
    {
        path: 'searchUnit',
        component: UnitSearchFormComponent,
        data: {
            hasAny: [
                'RIGHT_CM_EXA_COURSE_VIEW_EVENT_DATE'
            ]
        }
    },
    {
        path: 'searchUnitResult',
        component: UnitSearchResultComponent,
        data: {
            hasAny: [
                'RIGHT_CM_EXA_COURSE_VIEW_EVENT_DATE'
            ]
        }
    },
    {
        path: 'idAssignment',
        component: PersonIdAssignmentFormComponent,
        data: {
            hasAll: ['RIGHT_CS_PSV_PERSON_IMPORT_ORCID_IDS']
        }
    },
    {
        path: 'edit/:personId',
        component: PersonProfileEditFormComponent,
        data: {
            hasAny: [
                'RIGHT_CS_PSV_PROFILE_EDIT_PROFILE',
                'RIGHT_CS_PSV_PROFILE_EDIT_PROFILE_OWN',
            ],
        }
    }
];

// eslint-disable-next-line @typescript-eslint/naming-convention
export const PersonRoutesModule = hisChildRoutes( ROUTES );
